import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';

function ModelCardForm({ onSubmit, modelId, initialData = {} }) {
  const formType = modelId ? 'update' : 'create';
  const modelFormConfig = useSelector(
    state => state.config.configs.modelFormConfig?.fields || []
  );

  const [formData, setFormData] = useState({});

  useEffect(() => {
    // build initial formData keyed by config
    const initial = {};
    modelFormConfig.forEach(field => {
      initial[field.name] = initialData[field.name] ?? '';
    });
    setFormData(initial);
  }, [modelFormConfig, initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit(formData, formType, modelId);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        {modelFormConfig.map(field => (
          <Grid item xs={12} key={field.name}>
            {(field.type === 'text' || field.type === 'textarea') ? (
              <TextField
                label={field.label}
                variant="outlined"
                fullWidth
                multiline={field.type === 'textarea'}
                rows={field.type === 'textarea' ? 3 : 1}
                name={field.name}
                value={formData[field.name] || ''}
                onChange={handleChange}
                required={field.required}
              />
            ) : field.type === 'select' ? (
              <FormControl fullWidth required={field.required} margin="normal">
                <InputLabel>{field.label}</InputLabel>
                <Select
                  label={field.label}
                  name={field.name}
                  value={formData[field.name] || ''}
                  onChange={handleChange}
                >
                  {field.options.map(opt => (
                    <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : null}
          </Grid>
        ))}
      </Grid>
    </form>
  );
}

export default ModelCardForm;